import React, { Component } from 'react';

class App extends Component {
  componentDidMount() {
    this.initGoogleTranslate();
    this.addScript();
  }

  initGoogleTranslate = () => {
    window.gtranslateSettings = window.gtranslateSettings || {};
    window.gtranslateSettings['43217984'] = {
        "default_language": "ru",
        "languages": ["ru","en"],
        "wrapper_selector": "#gt-testwidget-43217984",
        "native_language_names": 1,
        "flag_style": "2d",
        "flag_size": 18,
        "horizontal_position": "inline",
        "flags_location": "assets\/images\/flags\/"
    };
  };

  addScript = () => {
    const script = document.createElement('script');
    script.src = '/gt.min.js';
    script.setAttribute('data-gt-widget-id', '43217984');
    script.async = true;
    document.body.appendChild(script);
  };

  render() {
    return <div id="gt-testwidget-43217984" />;
  }
}

export default App;